export const HTTP_INTERNAL_SERVER_ERROR = 500
export const HTTP_UNAUTHORIZED = 401
export const HTTP_TEMPORARY_REDIRECT = 307
export const HTTP_NOT_FOUND = 404
export const HTTP_OK = 200
export const HTTP_CREATED = 201
